shadow$provide[245] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Face:{enumerable:true, get:function() {
  return Face;
}}});
var UGLSL = require("../../../util/glsl.js");
var UJS = require("../../../util/js.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Face extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "object", "visible", "style", "line", "mesh", "face", "geometry", "position", "bind", "shade",];
  }
  constructor(node, context, helpers) {
    super(node, context, helpers);
    this.face = null;
  }
  resize() {
    if (this.bind.points == null) {
      return;
    }
    const dims = this.bind.points.getActiveDimensions();
    const {items, width, height, depth} = dims;
    if (this.face) {
      this.face.geometry.clip(width, height, depth, items);
    }
    if (this.line) {
      this.line.geometry.clip(items, width, height, depth);
    }
    if (this.bind.map != null) {
      const map = this.bind.map.getActiveDimensions();
      if (this.face) {
        return this.face.geometry.map(map.width, map.height, map.depth, map.items);
      }
    }
  }
  make() {
    let color, uniforms;
    this._helpers.bind.make([{to:"geometry.points", trait:"source"}, {to:"geometry.colors", trait:"source"}, {to:"mesh.map", trait:"source"},]);
    if (this.bind.points == null) {
      return;
    }
    let position = this.bind.points.sourceShader(this._shaders.shader());
    position = this._helpers.position.pipeline(position);
    const styleUniforms = this._helpers.style.uniforms();
    const lineUniforms = this._helpers.line.uniforms();
    const unitUniforms = this._inherit("unit").getUnitUniforms();
    const wireUniforms = {};
    wireUniforms.styleZBias = this._attributes.make(this._types.number());
    this.wireZBias = wireUniforms.styleZBias;
    const dims = this.bind.points.getDimensions();
    const {items, width, height, depth} = dims;
    const {line, shaded, fill, stroke, join} = this.props;
    if (this.bind.colors) {
      color = this._shaders.shader();
      this.bind.colors.sourceShader(color);
    }
    const mask = this._helpers.object.mask();
    const map = this._helpers.shade.map(this.bind.map != null ? this.bind.map.sourceShader(this._shaders.shader()) : undefined);
    const material = this._helpers.shade.pipeline();
    const faceMaterial = material || shaded;
    const lineMaterial = material || false;
    const objects = [];
    if (line) {
      const swizzle = this._shaders.shader();
      swizzle.pipe(UGLSL.swizzleVec4("yzwx"));
      swizzle.pipe(position);
      uniforms = UJS.merge(unitUniforms, lineUniforms, styleUniforms, wireUniforms);
      this.line = this._renderables.make("line", {uniforms, samples:items, strips:width, ribbons:height, layers:depth, position:swizzle, color, stroke, join, material:lineMaterial, mask, closed:true,});
      objects.push(this.line);
    }
    if (fill) {
      uniforms = UJS.merge(unitUniforms, styleUniforms, {});
      this.face = this._renderables.make("face", {uniforms, width, height, depth, items, position, color, material:faceMaterial, mask, map,});
      objects.push(this.face);
    }
    this._helpers.visible.make();
    return this._helpers.object.make(objects);
  }
  made() {
    return this.resize();
  }
  unmake() {
    this._helpers.bind.unmake();
    this._helpers.visible.unmake();
    this._helpers.object.unmake();
    return this.face = this.line = null;
  }
  change(changed, touched, init) {
    if (changed["geometry.points"] || touched["mesh"]) {
      return this.rebuild();
    }
    if (changed["style.zBias"] || changed["mesh.lineBias"] || init) {
      const {fill, zBias, lineBias} = this.props;
      return this.wireZBias.value = zBias + (fill ? lineBias : 0);
    }
  }
}
Face.initClass();

};